export type WalletType = {
  wallet: {
    balance: string;
    status: 'ACTIVE' | 'INACTIVE';
  };
};

export type TransactionType = {
  id: number;
  type: string;
  amount: string;
  runningBalance: string;
  createdAt: string;
};

export type PaginateType = {
  paginate: {
    page: number;
    limit: number;
    totalCount: number;
  };
};
export type WalletTransactionsType = WalletType &
  PaginateType & {
    transactions: TransactionType[];
  };

export type WalletErrorType = { status: number; message: string } | undefined;

export type WalletTopupResponseType = {
  id: number;
  balance: string;
  vat_amount: string;
  total_amount: string;
};

export enum TransactionTypeEnum {
  TOP_UP = 'TOP_UP',
  SPEND = 'SPEND',
  CONVERSION = 'CONVERSION',
  REVERSAL = 'REVERSAL',
}
